import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { JoinCta } from "./JoinCta";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white text-ink">
      <a href="#main" className="skip-link" data-testid="skip-to-content-link">Skip to main content</a>
      <Header />
      <main id="main" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      {pathname !== "/contact" && <JoinCta />}
      <Footer />
    </div>
  );
}
